import { sidebarActions } from '../../helpers/constants';

export const setSidebarItem = sidebarItem => {

  return {
    type: sidebarActions.CHANGE_SIDEBAR_ITEM,
    payload: sidebarItem
  };

}